import { InjectionToken, Type } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputItemType, ItemType } from '@libs/form/models';
import { InputBaseComponent } from './input-base.component';
import { ItemBaseComponent } from './item-base.component';

export type DynamicElementsMap = Partial<Record<ItemType, Type<ItemBaseComponent>>>;
export type DynamicInputItemsMap = Partial<Record<InputItemType, Type<InputBaseComponent>>>;

export const DYNAMIC_ELEMENTS_MAP: InjectionToken<DynamicElementsMap> = new InjectionToken('DYNAMIC_ELEMENTS_MAP');
export const DYNAMIC_ELEMENTS_MAP_EXTERNAL: InjectionToken<DynamicElementsMap> = new InjectionToken('DYNAMIC_ELEMENTS_MAP_EXTERNAL');
export const DYNAMIC_INPUT_ITEMS_MAP: InjectionToken<DynamicInputItemsMap> = new InjectionToken('DYNAMIC_INPUT_ITEMS_MAP');
export const PARENT_NG_CONTROL: InjectionToken<NgControl> = new InjectionToken('PARENT_NG_CONTROL');
